<template>
  <div>
    <div class="product-wrapper section-gap pb-0 mt-3">
      <!-- card info -->
      <div
        class="card container p-3"
        style="border: 2px solid; border-radius: 2%"
      >
        <!-- header section -->
        <div class="row mb-4">
          <!-- first section images-->
          <div class="col-sm-12 col-md-12 col-lg-5">
            <div class="mb-4">
              <!-- image -->
              <div class="feature-box-thumb mt-2">
                <img
                  v-if="ListOfData.ImageURL"
                  :src="baseURL + ListOfData.ImageURL"
                  class="img-fluid card-shadow"
                  alt="product image"
                  height="100%"
                  width="100%"
                />
                <img
                  v-else
                  src="/static/img/enNotAvail.png"
                  alt=""
                  height="100%"
                  width="100%"
                  class="card-img-top border-bottom"
                />
              </div>
              <!-- feature box thumb closed -->
            </div>
          </div>
          <!-- book info -->
          <div class="card col-sm-12 col-md-12 col-lg-7">
            <!-- Book Name -->
            <vx-tooltip
              style="
                background-color: #f78500;
                border-radius: 8px;
                position: relative;
                width: 100%;
              "
              class="mb-2"
            >
              <h1 class="p-2 font-weight-bold font-3x" style="color: #f2f2f2">
                {{ ListOfData.Name }}
              </h1>
            </vx-tooltip>
            <div class="mb-3">
              <!-- <h4 class="mb-2">{{ ListOfData.Name }}</h4> -->
              <div class="flex-1" style="padding-left: 5px">
                <label class="text-sm font-weight-bold opacity-75">{{
                  $t("Email")
                }}</label>
                <input
                  v-model="complain.Title"
                  :data-vv-as="$t('Email')"
                  class="w-full m-2"
                  v-validate="'required'"
                  name="Email"
                  style="width: 87%"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('Email')"
                  >{{ errors.first("Email") }}</span
                >
              </div>
              <div class="flex-1" style="padding-left: 5px">
                <label class="text-sm font-weight-bold opacity-75">{{
                  $t("Message")
                }}</label>
                <input
                  v-model="complain.Message"
                  :data-vv-as="$t('Message')"
                  class="w-full m-2"
                  v-validate="'required'"
                  name="Message"
                  style="width: 87%"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('Message')"
                  >{{ errors.first("Message") }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- back button -->
    <div
      class="col-sm-12 col-md-6 col-lg-6 mx-auto m-2"
      style="text-align: center"
    >
      <button
        @click="save"
        type="border"
        class="
          btn btn-primary
          rounded-pill
          text-white
          btn-lg
          rounded-pill
          m-3
          p-2
          pl-4
          pr-4
        "
      >
        {{ $t("save") }}
      </button>
      <button
        @click="back"
        type="border"
        class="
          btn btn-primary
          rounded-pill
          text-white
          btn-lg
          rounded-pill
          p-2
          pl-4
          pr-4
        "
      >
        {{ $t("back") }}
      </button>
    </div>
  </div>
</template>
<script>
import modulePageDetails from "@/store/PageDetails/modulePageDetails.js";
import { domain } from "@/globalComponents.js";

export default {
  data() {
    return {
      ListOfData: {},
      complain: {},
      baseURL: domain,
    };
  },
  components: {},
  methods: {
    back() {
      this.$router.go(-1);
    },
    save() {
      this.complain.LibraryID = this.$route.params.ID;
      this.complain.ContactTypeID = 1;
      this.$store
        .dispatch("DetailsList/addComplain", this.complain)
        .then((response) => {
          debugger;
          if (response.status == 200) {
            debugger;
            this.$router.go(-1);
            // this.$vs.notify({
            //   title: "Success",
            //   text: "The Complain success",
            //   color: "success",
            //   iconPack: "feather",
            //   icon: "icon-check",
            // });
          }
        })
        .catch(() => {});
    },
  },
  created() {
    debugger;
    if (!modulePageDetails.isRegistered) {
      debugger
      this.$store.registerModule("DetailsList", modulePageDetails);
      modulePageDetails.isRegistered = true;
    }
    this.complain = {};
    let ID = this.$route.params.ID;
    this.$store
      .dispatch("DetailsList/GetLibrary", ID)
      .then((response) => {
        if (response.status == 200) {
          this.ListOfData = response.data.data;
          this.isMounted = true;
        }
      })
      .catch(() => {});
  },
};
</script>
